<template>
  <div>
    <div v-if="pendingActionListInt.length < 1" class="empty-list_image">
      <strong>{{ lang('No Pending Action Found') }}...</strong>
      <img src="../../../assets/notfound.png" />
    </div>
    <div v-if="pendingActionListInt.length > 0" class="">
      <div>
        <el-input
          v-model="inputSearchPendingList"
          class="mb-3"
          style="width: calc(100% - 50px)"
          placeholder="Search Title / Date / Class / Level / Student Name"
        >
        </el-input>
        <span><i class="material-icons" style="width: 50px">search</i></span>
      </div>
      <div v-if="isPrincipal">
        <K2Row justify_content="flex-end" v-if="allowApproveList.length < 1">
          <!--<K2Confirm color="white"-->
          <!--:title="lang('You are going to approve all report list, continue?')"-->
          <!--theme="1" @confirm="checkBulkApprovePermission()" no-children="true"-->
          <!--:label="lang('Approve All')"/>-->
          <K2Confirm
            color="white"
            :title="lang('Are you sure you want to approve selected reports?')"
            theme="1"
            @confirm="handleBulkApprove()"
            no-children="true"
            :label="lang('Bulk Approve')"
            class="mr-1"
          />

          <K2Confirm
            color="white"
            :title="lang('Are you sure you want to reject selected reports?')"
            theme="1"
            @confirm="handleBulkReject()"
            no-children="true"
            :label="lang('Bulk Reject')"
          />
        </K2Row>

        <!--<K2Row space-between="true" etween style="width: 100%">-->
        <!--<K2Confirm color="white"-->
        <!--:title="lang('Are you sure you want to approve selected reports?')"-->
        <!--theme="1" @confirm="handleBulkApprove()" no-children="true"-->
        <!--:label="lang('Approve All')"/>-->
        <!--</K2Row>-->
      </div>

      <div>
        <data-tables :data="filterPendingActionList()" :table-props="tableProps" class="listTable" @selection-change="handleSelectionChange">
          <el-table-column v-if="isPrincipal" type="selection" width="55"> </el-table-column>
          <el-table-column
            v-for="pendingActionListInfo in pendingActionList"
            :prop="pendingActionListInfo.prop"
            :label="pendingActionListInfo.label"
            :key="pendingActionListInfo.prop"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column label="" width="100px">
            <template slot-scope="scope">
              <button class="pendingActionButton" @click="handleAction('PendingActionNext', scope.row.TermlyReportID, scope.row.TeRpStatus)">
                <span><i class="material-icons">playlist_add_check</i></span>
              </button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </div>
  </div>
</template>

<script>
import { lang } from '../../../locale'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Confirm from '../../../uiComponents/k2Confirm/k2Confirm'
import uiVariable from '../../../config/uiVariable'
import DataSource from '../../../data/datasource'
import K2Heading from '../../../uiComponents/k2Heading/k2Heading'
import K2Button from '../../../uiComponents/k2Button/k2Button'
import { getRole } from '@/helper/util_custom'

export default {
  name: 'TermlyModePending',
  components: { K2Button, K2Heading, K2Confirm, K2Row },
  props: ['pendingActionList', 'passInputSearchPendingList', 'pendingActionListInt', 'action', 'bulkApproval', 'allowApprove', 'ddlClass'],
  watch: {
    passInputSearchPendingList: function (value) {
      if (value) {
        this.inputSearchPendingList = value
      }
    },
  },
  data() {
    return {
      inputSearchPendingList: '',
      uiVariable: uiVariable,
      isPrincipal: '',
      selectedReports: [],
      allowApproveList: [],
      tableProps: {
        defaultSort: {
          prop: 'CreatedDate_edit',
          order: 'descending',
        },
      },
    }
  },
  mounted() {
    let userRole = getRole()
    this.isPrincipal = userRole === 'Principal'
  },
  methods: {
    lang,
    handleAction(action, TermlyReportID, TeRpStatus) {
      // switch (lang(TeRpStatus)) {
      //   case lang("Reject"):
      //   case lang("Rejected"):
      //     this.$emit("action", "PendingActionNext", TermlyReportID);
      //     break;
      //   case lang('Publish'):
      //   case lang('Published'):
      //     this.$emit("action", "Active", TermlyReportID);
      //     break;
      // }
      this.$emit('action', action, TermlyReportID)
    },
    handleSelectionChange(val) {
      this.selectedReports = val
    },
    async checkBulkApprovePermission() {
      // this.$emit("bulkApproval", "Approved");
      let allowApproveList = []
      for (const d of this.pendingActionListInt) {
        let isAllow = await this.checkTermlyReportFlow(d.TermlyReportID, d.ClasID)
        if (isAllow) {
          allowApproveList.push(d)
        }
      }
      this.allowApproveList = allowApproveList
      this.filterPendingActionList()
    },
    async handleBulkApprove() {
      this.$emit('bulkApproval', 'Approved', this.selectedReports)
    },
    async handleBulkReject() {
      this.$emit('bulkApproval', 'Reject', this.selectedReports)
    },
    async checkTermlyReportFlow(termlyReportID, currentClassID) {
      try {
        const response = await DataSource.shared.checkTermlyReportFlow(termlyReportID, currentClassID)
        if (response) {
          if (response.code === '1') {
            return true
          } else if (response.code === '2') {
            return false
          } else if (response.code === '99') {
            console.log('Check Summative Report Flow: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            window.location.replace('/')
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    handlePendingList() {
      this.allowApproveList = []
    },
    filterPendingActionList() {
      if (this.allowApproveList && this.allowApproveList.length) {
        return this.allowApproveList
      } else if (this.inputSearchPendingList !== '') {
        return this.pendingActionListInt.filter(
          data =>
            data.Title.toLowerCase().includes(this.inputSearchPendingList.toLowerCase()) ||
            data.ClassName.toLowerCase().includes(this.inputSearchPendingList.toLowerCase()) ||
            data.LevelName.toLowerCase().includes(this.inputSearchPendingList.toLowerCase()) ||
            data.StudentName.toLowerCase().includes(this.inputSearchPendingList.toLowerCase()) ||
            data.CreatedDate.toLowerCase().includes(this.inputSearchPendingList.toLowerCase())
        )
      } else {
        return this.pendingActionListInt
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../termly';
</style>
